<template>
	<div class="modal-window" v-on:touchstart="onTouchStart" v-on:touchmove="onVScroll" v-on:touchend="onTouchEnd">
		<div class="modal-header primary white--text">
			<div class="modal-header-title">{{ title }}</div>
			<v-btn fab flat class="pa-0 ma-0 modal-close"
				v-on:click="onClose"
			>
				<v-icon color="white">close</v-icon>
			</v-btn>
			<slot name="header" />
		</div>
		<div class="modal-content-wrap">
			<div class="modal-content" 
				v-bind:style="styleContentHeight" 
				v-on:touchstart="onVScrollStartContent"
				v-on:click="onCloseModalContent"
			>
				<slot />
			</div>
		</div>
		<transition>
			<div class="modal-bottom" 
				v-bind:style="styleBottomHeight"
				v-on:touchstart="onVScrollStartBottom"
				v-if="bottom_value"
			>
				<slot name="bottom" />
			</div>
		</transition>
	</div>
</template>
<script>
const SCROLL_TARGET = {
	CONTENT: 0,
	BOTTOM: 1,
};
export default {
	name: 'GBModalVScrollable',
	props: [
		'title',
		'header_height',
		'bottom_height',
		'bottom_value',
	],
	data: function() {
		return {
			touch_y: 0,
			scroll_target: null,
			mouse_pointer:	{
				x: 0,
				y: 0,
			},
		};
	},
	methods: {
		onTouchStart: function(e){
			let obj = e.targetTouches[0] ? e.targetTouches[0] : e;
			this.mouse_pointer.x = obj.pageX;
			this.mouse_pointer.y = obj.pageY;
		},
		onTouchEnd: function(){
			this.mouse_pointer.x = 0;
			this.mouse_pointer.y = 0;
		},
		onClose: function() {
			this.filter_name = '';
			this.mouse_pointer.x = 0;
			this.mouse_pointer.y = 0;
			this.$emit('close');
		},
		onVScroll: function(e) {
			let elm = e.target;
			let btn = elm.classList.contains('v-btn') ? elm : elm.closest('.v-btn');
			if (btn)
				return;
			
			let input = elm.classList.contains('v-input') ? elm : elm.closest('.v-input');
			if (input && !input.classList.contains('v-input--is-focused'))
				return;

			if(this.$el.getElementsByClassName('v-input--is-focused')[0])
				return;
			
			let obj = e.targetTouches ? e.targetTouches[0] : e;
			let page_y = obj.pageY;
	
			let x = obj.clientX ? obj.clientX : obj.pageX;
			let y = obj.clientY ? obj.clientY : obj.pageY;
			let move = Math.sqrt(Math.pow((this.mouse_pointer.x - x),2) + Math.pow((this.mouse_pointer.y - y),2));
			if (8 >  move)
				return;

			if(this.scroll_target === SCROLL_TARGET.CONTENT){
				let el_target = obj.target.closest('.modal-window').querySelector('.modal-content');
				let scroll_height = el_target.scrollHeight;
				let scroll_top = el_target.scrollTop;
				let client_height = el_target.clientHeight;
		
				if(page_y < this.header_height) {
					e.preventDefault();
				}
				if(client_height < scroll_height) {
					if(this.touch_y <= page_y && scroll_top === 0){
						e.preventDefault();
					}
					if(this.touch_y > page_y && scroll_height - scroll_top === client_height){
						e.preventDefault();
					}
				}else{
					e.preventDefault();
				}
			}else if(this.scroll_target === SCROLL_TARGET.BOTTOM){
				let el_target = obj.target.closest('.modal-window').querySelector('.modal-bottom');
				let scroll_height = el_target.scrollHeight;
				let scroll_top = el_target.scrollTop;
				let client_height = el_target.clientHeight;
		
				if(page_y < this.$store.getters.height - this.bottom_height) {
					e.preventDefault();
				}
				if(client_height < scroll_height) {
					if(this.touch_y <= page_y && scroll_top === 0){
						e.preventDefault();
					}
					if(this.touch_y > page_y && scroll_height - scroll_top === client_height){
						e.preventDefault();
					}
				}else{
					e.preventDefault();
				}
			}
			
			this.touch_y = page_y;
		},
		onVScrollStartContent: function(e) {
			let obj = e.targetTouches ? e.targetTouches[0] : e;
			this.scroll_target = SCROLL_TARGET.CONTENT;
			this.touch_y = obj.pageY;
		},
		onVScrollStartBottom: function(e) {
			let obj = e.targetTouches ? e.targetTouches[0] : e;
			this.scroll_target = SCROLL_TARGET.BOTTOM;
			this.touch_y = obj.pageY;
		},
		onCloseModalContent: function(e) {
			this.$emit('click-modal-content', e);
		},
	},
	computed: {
		styleContentHeight: function() {
			return { 
				height: (this.$store.getters.height - this.header_height - this.bottom_height) + 'px',
				transition: 'height 0.3s ease',
			};
		},
		styleBottomHeight: function() {
			return { height: this.bottom_height + 'px', };
		},
	},
};
</script>
<style>
	.modal-window {
		position: relative;
		align-self: center;
		background: #fff;
		overflow: hidden;
		margin: 0;
		width: 350px;
		min-height: 100%;
		bottom: 0;
		transition: .4s cubic-bezier(.25,.8,.5,1);
	}
	.modal-window .modal-header {
		position: relative;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		height: 115px;
	}
	.modal-window .modal-header-title {
		width: 100%;
		text-align: center;
		font-size: 20px;
		margin-top: 13px;
		height: 43px;
		user-select: none;
	}
	.modal-window .modal-close {
		position: absolute;
		top: 0px;
		right: 0px;
	}

	.modal-window .modal-content-wrap {
		overflow-y: hidden;
		overflow-x: hidden;
		width: 358px;
	}

	.modal-window .modal-content {
		overflow-y: scroll;
		overflow-x: hidden;
		width: 100%;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
	}
	
	.modal-window .modal-bottom {
		position: fixed;
		bottom: 0px;
		right: -8px;
		width: 358px;
		background-color: white;
		box-shadow: -5px -5px 5px rgba(0,0,0,0.2);
		overflow-y: scroll;
		overflow-x: hidden;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
	}
</style>
<style scoped>
	.v-enter-active, .v-leave-active {
		transition: all 0.3s ease-in;
	}
	.v-enter {
		transform: translateY(10px);
	}
	.v-enter, .v-leave-to {
		opacity: 0;
	}
</style>
